import settings from "app/settings"

const api_root = settings.API_ROOT
const loginApiRoot = api_root + "login/"
const endUserAuthApiRoot = api_root + "authenticate/"
const signupApiRoot = api_root + "register/"

export class LoginApi {
    static login(email, password) {
        return fetch(loginApiRoot, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        })
            .then(response => {
                return response.json()
            })
            .catch(error => {
                return error
            })
    }
    static auth_end_user(email, password) {
        return fetch(endUserAuthApiRoot, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        })
            .then(response => {
                return response.json()
            })
            .catch(error => {
                return error
            })
    }
}

export class SignupApi {
    static signup(details) {
        return fetch(signupApiRoot, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(details),
        })
            .then(response => {
                return response.json()
            })
            .catch(error => {
                return error
            })
    }
}



// WEBPACK FOOTER //
// ./src/features/auth/utils.js